export enum ROLES {
  OFFICER = 'officer',
  UNREGISTERED = 'unregistered-officer',
}
